var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4853 3.30783H4.83043C4.59398 3.30783 4.40234 3.11619 4.40234 2.87975C4.40234 2.6433 4.59398 2.45166 4.83043 2.45166H12.4853C12.7218 2.45166 12.9134 2.6433 12.9134 2.87975C12.9134 3.11619 12.7218 3.30783 12.4853 3.30783Z",
    fill: "#34656D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6334 5.71652H4.83141C4.59496 5.71652 4.40332 5.52488 4.40332 5.28844C4.40332 5.05199 4.59496 4.86035 4.83141 4.86035H10.6334C10.8698 4.86035 11.0615 5.05199 11.0615 5.28844C11.0615 5.52488 10.8698 5.71652 10.6334 5.71652Z",
    fill: "#34656D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77981 8.12473H4.83043C4.59398 8.12473 4.40234 7.93309 4.40234 7.69664C4.40234 7.46019 4.59398 7.26855 4.83043 7.26855H8.77981C9.01625 7.26855 9.20789 7.46019 9.20789 7.69664C9.20789 7.93309 9.01625 8.12473 8.77981 8.12473Z",
    fill: "#34656D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92705 10.5334H4.83043C4.59398 10.5334 4.40234 10.3418 4.40234 10.1053C4.40234 9.86889 4.59398 9.67725 4.83043 9.67725H6.92691C7.16336 9.67725 7.355 9.86889 7.355 10.1053C7.355 10.3418 7.1635 10.5334 6.92705 10.5334Z",
    fill: "#34656D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73082 10.5336C1.49437 10.5336 1.30273 10.342 1.30273 10.1056V2.87975C1.30273 2.6433 1.49437 2.45166 1.73082 2.45166C1.96727 2.45166 2.15891 2.6433 2.15891 2.87975V10.1056C2.15891 10.3421 1.96727 10.5336 1.73082 10.5336Z",
    fill: "#34656D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499375 4.53958C0.389785 4.53958 0.280195 4.49777 0.196718 4.41416C0.0294793 4.24706 0.0294793 3.97594 0.196718 3.80884L1.42804 2.57752C1.59513 2.41029 1.86625 2.41043 2.03335 2.57752L3.26481 3.80884C3.43205 3.97608 3.43205 4.24706 3.26481 4.4143C3.09757 4.58154 2.82645 4.58139 2.65935 4.4143L1.73055 3.48564L0.801889 4.4143C0.718555 4.49777 0.608965 4.53958 0.499375 4.53958Z",
    fill: "#34656D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.cebe117ef60858cc7dd563c0fead20c6.svg";
export { ForwardRef as ReactComponent };